import { configureAnatomy } from './anatomy';
import { AssociatedSymptom } from './associated-symptom';
import { Color } from './color';
import { Decreased } from './decreased';
import { Distribution } from './distribution';
import { LesionConfig } from './lesion-config';
import { LesionSurface } from './lesion-surface';
import { LesionType } from './lesion-type';
import { Onset } from './onset';
import { Palpation } from './palpation';
import { Pattern } from './pattern';
import { Provoked } from './provoked';
import { Quality } from './quality';
import { Severity } from './severity';

/**
 * Parse the preloaded localized finding enums.
 *
 * @param data Preloaded localized finding enums
 */
export const configureLocalizedFindings = (data: any): void => {
  // Anatomy tree structure – has own parser
  configureAnatomy(data.anatomy);
  // Parse localized finding enum types
  data.associated_symptom.forEach((i: any) => new AssociatedSymptom(i.id, i.name));
  data.color.forEach((i: any) => new Color(i.id, i.name));
  data.decreased.forEach((i: any) => new Decreased(i.id, i.name));
  data.distribution.forEach((i: any) => new Distribution(i.id, i.name));
  data.lesion_config.forEach((i: any) => new LesionConfig(i.id, i.name));
  data.lesion_surface.forEach((i: any) => new LesionSurface(i.id, i.name));
  data.lesion_type.forEach((i: any) => new LesionType(i.id, i.name));
  data.onset.forEach((i: any) => new Onset(i.id, i.name));
  data.palpation.forEach((i: any) => new Palpation(i.id, i.name));
  data.pattern.forEach((i: any) => new Pattern(i.id, i.name));
  data.provoked.forEach((i: any) => new Provoked(i.id, i.name));
  data.quality.forEach((i: any) => new Quality(i.id, i.name));
  data.severity.forEach((i: any) => new Severity(i.id, i.name));
};
